import React from "react";
import { GoAway, Add, Upload } from "../Icons/Interface";

// Define right icon options as a union type
export type RightIconType = "External" | "Delete" | "Upload" | null;

// Define props interface
interface CustomButtonProps {
	onClick?: (event?: any) => void;
	leftIcon?: React.ReactNode;
	title?: string;
	text: string;
	rightIcon?: RightIconType;
	className?: string;
	disabled?: boolean;
}

const CustomButton: React.FC<CustomButtonProps> = ({
	onClick,
	leftIcon,
	title,
	text,
	rightIcon = null,
	className = "border-primary-inactive",
	disabled = false
}) => {
	// Function to render the right icon based on enumeration
	const renderRightIcon = (): React.ReactNode => {
		if (!rightIcon) return null;

		switch (rightIcon) {
			case "External":
				return Add();
			case "Delete":
				return GoAway();
			case "Upload":
				return Upload();
			default:
				return null;
		}
	};

	return (
		<div className="relative text-primary" aria-label="Button">
			{title && (
				<span className="absolute -top-2.5 left-6 px-1 text-xs rounded bg-primary-background z-footer">
					{title}
				</span>
			)}

			<button
				onClick={onClick}
				disabled={disabled}
				className={`flex items-center justify-between px-4 py-3 w-full border rounded-full ${disabled ? "opacity-50 cursor-not-allowed" : ""} ${className}`}
			>
				{leftIcon && <span className="mr-3">{leftIcon}</span>}
				<div className="flex items-center flex-grow">
					<span
						className={`${leftIcon ? "text-center mx-auto" : "text-left pl-3"}`}
					>
						{text}
					</span>
				</div>
				<div className="flex items-center ml-2 fill-primary-active">
					{renderRightIcon()}
				</div>
			</button>
		</div>
	);
};

export default CustomButton;
